﻿import $ from "jquery";
import anime from 'animejs';
import barba from "@barba/core";
import LocomotiveScroll from 'locomotive-scroll';
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay'
import Choices from 'choices.js';
import { setupPrevNextBtns, listenForPrevBtnClick, listenForNextBtnClick, disablePrevNextBtns } from "./utils/PrevNextButtons";
import videojs from "video.js";
import "videojs-youtube";
import lottie from "lottie-web";
import { createPopper } from '@popperjs/core';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';

import WindowUtils from './utils/WindowUtils';
import GridDebug from './utils/GridDebug';
import Utils from "./utils/Utils";
import ScrollLock from "./utils/ScrollLock";
// import { Dom } from "@barba/core/dist/core/src/utils";

jQuery = $;

// new GridDebug(12,0);

const WU = new WindowUtils();
if (WU.isTouch()) {
    $('html').addClass('isTouch');
}
if (WU.isSafari()) {
    $('html').addClass('isSafari');
}

const loadImages = (parent = document) => {
    parent.querySelectorAll('.imageRender:not(.imageRender--loaded)').forEach((img) => {
        let url = img.getAttribute('data-url');
        let cover = img.querySelector('.imageRender_cover');

        Utils.loadImage(url).then(() => {
            cover.style.backgroundImage = 'url(' + url + ')';
            img.classList.add('imageRender--loaded');
        });
    });
};


let scroll;

const createScroll = (parent = document) => {
    let hasSmooth;
    if (!document.querySelector('body').classList.contains('no-smooth-scroll')) {
        hasSmooth = true
    }else{
        hasSmooth = false
    }
    scroll = new LocomotiveScroll({
        el: parent.querySelector('.lcs[data-scroll-container]'),
        smooth: true,
        getSpeed: true,
        getDirection: true,
        gestureDirection: 'vertical',
        direction: 'vertical',
        smooth:hasSmooth,
        tablet: {
            smooth: hasSmooth
        },
        smartphone: {
            smooth: false
        }
    });

    scroll.stop();

    scroll.on('call', (value, way, obj) => {
        // if (WU.isXS()) return;

        let calls = (typeof value === 'string') ? [value] : value;
        scrollAnimations(calls, way, obj);
    });
};

const scrollAnimations = (calls, way, obj) => {
    calls.forEach(call => {
        if (call === 'setFaqCategory') {
            let category = obj.el.getAttribute('data-category');
            let link = document.querySelector('.faqCategories a[data-category="' + category + '"]');

            if (link) {
                if (way === 'enter') {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            }
        }

        if (call === 'toggleVideo') {
            let videoPlayer = obj.el.querySelector('video');
            if (videoPlayer && videoPlayer.getAttribute('src') != '') {
                if (way === 'enter') {
                    videoPlayer.play();
                } else {
                    videoPlayer.pause();
                }
            }
        }
        
        if (call === 'timelineImages') {
            let stack = obj.el.querySelector('.timeline_images_stack');
            let items = stack.querySelectorAll('.timeline_images_stack_item');
            if (stack && items.length > 0 && !stack.classList.contains('animated')) {
                stack.classList.add('animated');
                if (way === 'enter') {
                    anime({
                        targets: items,
                        scale: [0,1],
                        translateX: function() { return anime.random(-30, 30); },
                        translateY: function() { return anime.random(-30, 30); },
                        rotate: function() { return anime.random(-10, 10); },
                        easing: 'easeOutElastic(1, .6)',
                        duration: 1000,
                        delay: anime.stagger(200)
                    })
                }
            }
        }
        
    });
};

const scrollTop = (force) => {
    if (!scroll) return;
    if (force) {
        scroll.scrollTo(0, { duration: 0, disableLerp: true });
    } else {
        scroll.scrollTo(0, { duration: 1000, easing: [0.90, 0.00, 0.00, 1.00] });
    }
};

const scrollTo = (elt, offset = 0) => {
    scroll.scrollTo(elt, { duration: 1000, easing: [0.90, 0.00, 0.00, 1.00], offset: offset });
};
const initScrollUp = () => {
    const button = document.querySelector('.top-button')
    if (button) {
        if (window.scrollY > window.innerHeight) {
            button.classList.add('visible')
        }else{
            button.classList.remove('visible')
        }
        window.addEventListener('scroll',()=>{
            if (window.scrollY > window.innerHeight) {
                button.classList.add('visible')
            }else{
                button.classList.remove('visible')
            }
        })
        button.addEventListener('click',()=>scroll.scrollTo(0, { duration: 1000, easing: [0.90, 0.00, 0.00, 1.00] }))
    }
};

const initModules = () => {
    initScrollUp();
    initCollapses();
    initTabs();
    initCarousels();
    initSubSection();
    initLogos();
    initTestimonials();
    initChainedFlow();
    initCustomSelect();
    initTooltips();
    initAnchors();
    initTable();
}

const initCollapses = () => {
    if (document.querySelectorAll('[data-collapse]')) {
        document.querySelectorAll('[data-collapse]').forEach((collapse) => {
            let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            let collapseContent = collapse.querySelector('[data-collapse-content]');
            if (collapse.hasAttribute('data-open')) {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                anime({
                    targets: collapseContent,
                    height: contentHeight,
                    duration: 0,
                    complete: () => { 
                        scroll.update();
                     }
                });
            }
            collapseToggle.addEventListener('click', (e) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                if (collapse.closest('[data-collapse-content]')) {
                    let parent = collapse.closest('[data-collapse-content]')
                    anime({
                        targets: parent,
                        height: collapse.hasAttribute('data-collapse-opened') ? parent.offsetHeight + contentHeight: parent.offsetHeight - contentHeight,
                        easing: 'easeOutExpo',
                        duration: 600,
                        complete: () => { 
                            scroll.update();
                         }
                    });
                }
                anime({
                    targets: collapseContent,
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    easing: 'easeOutExpo',
                    duration: 600,
                    complete: () => { 
                        scroll.update();

                     }
                });
            })
        });

        const resizeCollapsesContents = () => {
            if (document.querySelectorAll('[data-collapse-opened]')) {
                document.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
                });
            }
        };

        window.addEventListener('resize', Utils.debounce(() => { resizeCollapsesContents() }), { passive: true });
    }
};

const initTabs = () => {
    if (document.querySelectorAll('.pSection--tabs .tabs')) {
        document.querySelectorAll('.pSection--tabs').forEach((sectionTabs) => {
            let tabsDOM ={
                labelsElt: sectionTabs.querySelector('.tabs_labels'),
                labels: sectionTabs.querySelectorAll('.tabs_labels button'),
                renderElt: sectionTabs.querySelectorAll('.tabs_render'),
                items: sectionTabs.querySelectorAll('.tabs_item')
            };

            tabsDOM.labels.forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    e.preventDefault();
                    let index = elt.getAttribute('data-tab');

                    if (sectionTabs.querySelector('.tabs_labels .active')) {
                        sectionTabs.querySelector('.tabs_labels .active').classList.remove('active');
                    }
                    if (sectionTabs.querySelector('.tabs_item.active')) {
                        sectionTabs.querySelector('.tabs_item.active').classList.remove('active');
                    }

                    elt.classList.add('active');
                    sectionTabs.querySelector('.tabs_item[data-tab="' + index + '"]').classList.add('active');
                    scroll.update();
                })
            });
        });
    }
};

const initCarousels = () => {
    if (document.querySelectorAll('.pSection--carousel .carousel')) {
        document.querySelectorAll('.pSection--carousel .carousel').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let domEmblaPrev = domElt.querySelector('.carousel_nav_prev');
            let domEmblaNext = domElt.querySelector('.carousel_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = { align: "start", loop: loop, dragFree: dragFree, draggable: true, containScroll: 'trimSnaps' };
            let domEmblaPlugins = [];
            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);

            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { scroll.update(); });
        })
    }
};

const initSubSection = () => {
    if (document.querySelectorAll('.pSection--sub_section .sub_section')) {
        document.querySelectorAll('.pSection--sub_section .sub_section').forEach((subSection) => {
            subSection.querySelectorAll('.sub_section_content_link').forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    e.preventDefault();
                    let index = elt.getAttribute('data-sub');

                    if (subSection.querySelector('.sub_section_content.active')) {
                        subSection.querySelector('.sub_section_content.active').classList.remove('active');
                    }
                    if (subSection.querySelector('.sub_section_media.active')) {
                        subSection.querySelector('.sub_section_media.active').classList.remove('active');
                    }

                    elt.closest('.sub_section_content').classList.add('active');
                    subSection.querySelector('.sub_section_media[data-sub="' + index + '"]').classList.add('active');
                    scroll.update();
                })
            });
        });
    }
};

const initLogos = () => {
    // if (document.querySelectorAll('.pSection--logos .logos')) {
    //     document.querySelectorAll('.pSection--logos .logos').forEach((domElt) => {
    //         let domEmbla = domElt.querySelector('.embla');
    //         let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
    //         let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
    //         let autoplay = Autoplay(
    //             { delay: 3000, stopOnInteraction: true },
    //             (emblaRoot) => emblaRoot.parentElement
    //         );
            
    //         let domEmblaOptions = { align: "start", loop: true, dragFree: dragFree, draggable: true, containScroll: 'trimSnaps' };
    //         let domEmblaPlugins = [autoplay];
    //         let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
    //         embla.on("init", () => { scroll.update(); });
    //     })
    // }
};
const initCustomSelect =  ()=>{
    const selectElements = document.querySelectorAll('.custom-select');
    const getValueFromPath = (obj, path) => {
        // Si le chemin ne contient pas de point, accédez directement à la clé
        if (!path.includes('.')) {
            return obj[path] !== undefined ? obj[path] : undefined;
        }
        
        // Sinon, divisez le chemin et parcourez l'objet
        return path.split('.').reduce((acc, key) => {
            return acc && acc[key] !== undefined ? acc[key] : undefined;
        }, obj);
    };
    selectElements.forEach(selectElement => {
        // Vérifier si l'élément est déjà initialisé
        if (selectElement.classList.contains('choices__input')) {
            return;
        }

        const placeholder = selectElement.querySelectorAll('option').innerText
        const choices = new Choices(selectElement, {
            placeholder: true,
            searchChoices: false,
            maxItemCount: 1,
            searchResultLimit: 4,
            removeItemButton: true,
            loadingText: 'Chargement...',
            noResultsText: 'Aucun résultat trouvé',
            noChoicesText: 'Aucun choix disponible',
            itemSelectText: 'Sélectionner',
            uniqueItemText: 'Seules des valeurs uniques peuvent être ajoutées',
            customAddItemText: 'Seules les valeurs correspondant à des conditions spécifiques peuvent être ajoutées',
            allowHTML: true
        });
        // Fonction de debounce
        function debounce(func, wait) {
            let timeout;
            return function() {
                const context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }
// Fonction pour effectuer la requête fetch
const fetchCompanies = (searchTerm) => {
    const url = `https://suggestions.pappers.fr/v2?cibles=nom_entreprise,siren,siret&q=${searchTerm}`;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            // Utiliser un Set pour éviter les doublons
            const uniqueResults = new Set();

            // Récupérer tous les résultats des cibles
            const choicesData = [];

            // Parcourir les clés de l'objet résultats
            for (const key of Object.keys(data)) {
                const items = data[key];

                items.forEach(item => {
                    if (!uniqueResults.has(item.siren)) {
                        uniqueResults.add(item.siren);
                        choicesData.push({
                            label: `${item.nom_entreprise} ${item.siege.code_postal ? `(${item.siege.code_postal})`:'' }`,
                            value: item.siret ? item.siret : item.siren,
                            customProperties: { ...item }
                        });
                    }
                });
            }
            choicesData.reverse()
            // Effacer les choix existants et ajouter les nouveaux choix
            choices.clearChoices();
            choices.setChoices(choicesData);
        })
        .catch(error => {
            console.error('Erreur lors de la requête fetch:', error);
        });
};



        // Appliquer le debounce à la fonction fetchCompanies avec un délai de 1000ms
        const debouncedFetchCompanies = debounce(fetchCompanies, 1000);

        // Ajouter l'écouteur d'événement
        selectElement.addEventListener('search', function(event) {
            const searchTerm = event.detail.value;
            if (searchTerm && searchTerm.length > 1) {
                debouncedFetchCompanies(searchTerm);
            }
        });

        
    

        selectElement.addEventListener('choice', function(event) {
            const selectedItem = event.detail.choice.customProperties;
            const prefillData = JSON.parse(selectElement.getAttribute('data-prefill'));
            const parentForm = selectElement.closest('.formBloc');
            const effectifSIRENE = {
                "00": "0 salarié",
                "01": "1 ou 2 salariés",
                "02": "3 à 5 salariés",
                "03": "6 à 9 salariés",
                "11": "10 à 19 salariés",
                "12": "20 à 49 salariés",
                "21": "50 à 99 salariés",
                "22": "100 à 199 salariés",
                "31": "200 à 499 salariés",
                "41": "500 à 999 salariés",
                "42": "1000 à 1999 salariés",
                "51": "2000 à 4999 salariés",
                "52": "5000 salariés ou plus",
                "NN": "Effectif inconnu"
            };
            
            // Fonction pour obtenir la valeur à partir d'un chemin
            const getValueFromPath = (obj, path) => {
                return path.split('.').reduce((acc, key) => {
                    return acc && acc[key] !== undefined ? acc[key] : undefined;
                }, obj);
            };
        
            // Remplissez les champs appropriés avec les valeurs de prefillData
            for (const [key, value] of Object.entries(prefillData)) {
                const field = parentForm.querySelector(`#${value}`);
                if (field) {
                    // Utilisez la fonction pour obtenir la valeur depuis selectedItem
                    const selectedValue = getValueFromPath(selectedItem, key);
                    if (selectedValue !== undefined) {
                        setTimeout(() => {
                            if (key == "tranche_effectif") {                                
                                field.value = effectifSIRENE[selectedValue] ? effectifSIRENE[selectedValue] : effectifSIRENE["00"];
                            }else{
                                field.value = selectedValue;
                            }
                            // Déclenche l'événement 'input' pour notifier les changements
                            field.dispatchEvent(new Event('input', { bubbles: true }));
                        }, 200);
                    }
                }
            }
        });
        
        

        // Ajoutez un écouteur d'événements pour le retrait d'un item
        selectElement.addEventListener('removeItem', function(event) {
            const parentForm = selectElement.closest('.formBloc');
            // Effacer les valeurs des champs lorsque l'item est retiré
            const prefillData = JSON.parse(selectElement.getAttribute('data-prefill'));
            for (const value of Object.values(prefillData)) {
                const field = parentForm.querySelector(`#${value}`);
                if (field) {
                    field.value = ''; // Vider le champ
                    field.dispatchEvent(new Event('input', {bubbles: true}));
                }
            }
        });
    
    });

}
const initChainedFlow = () => {
    const checkSlides = ()=> {
        const width = window.innerWidth;
    
        if (width <= 767) {
            return 2;
        } else if (width > 767 && width <= 930) {
            return 4;
        } else {
            return 6;
        }
    }
    if (document.querySelectorAll('.pSection--chainedFlow')) {
        document.querySelectorAll('.pSection--chainedFlow').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let slides = domElt.querySelectorAll('.embla__slide');
            let container = domElt.querySelector('.embla__container');
            let domEmblaPrev = domElt.querySelector('.chainedFlow_nav_prev');
            let domEmblaNext = domElt.querySelector('.chainedFlow_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = { align: "center",active: checkSlides() < slides.length , loop: loop, dragFree: dragFree, draggable: WU.isTouch(), containScroll: 'trimSnaps' };
            let domEmblaPlugins = [];
            if(checkSlides() > slides.length){
                container.style.justifyContent = 'center'
            }
            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);
            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { scroll.update(); });
        })
    }
};
const initTestimonials = () => {
    if (document.querySelectorAll('.pSection--testimonials .testimonials')) {
        document.querySelectorAll('.pSection--testimonials .testimonials').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let domEmblaPrev = domElt.querySelector('.testimonials_nav_prev');
            let domEmblaNext = domElt.querySelector('.testimonials_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = { align: "start", loop: loop, dragFree: dragFree, draggable: WU.isTouch(), containScroll: 'trimSnaps' };
            let domEmblaPlugins = [];
            
            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);

            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { scroll.update(); });
        })
    }
};

const initAnchors = () => {
    let anchor, anchorElt;

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener("click", (event) => {
            anchor = link.getAttribute('href').substring(1);
            if (anchor != '') {
                anchorElt = document.querySelector('[data-anchor="' + anchor + '"]');
                if (anchorElt) {
                    let offset = (anchorElt.getAttribute('data-anchor-offset')) ? parseInt(anchorElt.getAttribute('data-anchor-offset')) : 0;
                    scrollTo(anchorElt, offset);
                }
            }
        });
    });

    if (window.location.hash) {
        anchor = window.location.hash.substring(1);
        anchorElt = document.querySelector('[data-anchor="' + anchor + '"]');
        if (anchorElt) {
            setTimeout(() => {
                let offset = (anchorElt.getAttribute('data-anchor-offset')) ? parseInt(anchorElt.getAttribute('data-anchor-offset')) : 0;
                scrollTo(anchorElt, offset);
            }, 500);
        }
    }
};

const initTable = ()=>{
    const tables = document.querySelectorAll('.table-free');
    tables.forEach(table=>{
        let json = table.querySelector('script')
        if (json) {
            json = JSON.parse(json.textContent)
            const desktop = document.createElement('div')
            desktop.classList.add('table-desktop')
            const mobile = document.createElement('div')
            mobile.classList.add('table-mobile')
            table.appendChild(desktop)
            table.appendChild(mobile)
            json.forEach((row,i)=>{
                const rowDiv = document.createElement('div')
                if (i == 0) {
                    rowDiv.classList.add('table-head')
                }else{
                    rowDiv.classList.add('table-row')
                }
                rowDiv.classList.add(`size-${json[0].length}`)
                row.forEach(value=>{
                    const valueDiv = document.createElement('div')
                    valueDiv.innerHTML = value
                    rowDiv.appendChild(valueDiv)
                })
                desktop.appendChild(rowDiv)
            })

            json.forEach((row,i)=>{
                if (i > 0) {
                    for (let index = 0; index < json[0].length; index++) {
                        const rowDiv = document.createElement('div')
                        if (index == 0) {
                            rowDiv.classList.add('table-head')
                        }else{
                            rowDiv.classList.add('table-row')
                        }
                        const valueDiv1 = document.createElement('div')
                        valueDiv1.innerHTML = json[0][index]
                        rowDiv.appendChild(valueDiv1)
                        const valueDiv2 = document.createElement('div')
                        valueDiv2.innerHTML = row[index]
                        rowDiv.appendChild(valueDiv2)
                        mobile.appendChild(rowDiv)
                }
            }
            })
        }

    })
}

const initTooltips = () => {
    if (document.querySelectorAll('.tooltip')) {
        document.querySelectorAll('.tooltip').forEach((domElt) => {
            domElt.addEventListener('click', (e) => {
                e.preventDefault();
                if (!domElt.classList.contains('visible')) {
                    scroll.stop();
                    ScrollLock.enable();
                    domElt.classList.add('visible');
                    domElt.querySelector('.tooltip_element_scroller').scrollTop = 0;
                    document.addEventListener("click", (event) => {
                        const isClickInside = domElt.contains(event.target);
                    
                        if (!isClickInside) {
                            domElt.classList.remove('visible');
                            scroll.start();
                            ScrollLock.disable();
                        }
                    });
                }
            })
        });
    }
};

const initMediaYT = () => {
    // let popinYT = document.querySelector('.mediaYTPopin');
    // if (document.querySelectorAll('[data-ytpopin]')) {
    //     document.querySelectorAll('[data-ytpopin]').forEach((domElt) => {
    //         domElt.addEventListener('click', (e) => {
    //             scroll.stop();
    //             ScrollLock.enable();
    //             e.preventDefault();
    //             let ytId = domElt.getAttribute('data-ytpopin');
    //             let item = popinYT.querySelector('.mediaYTPopin_item[data-yt="' + ytId + '"]');
    //             popinYT.classList.add('visible');
    //             item.classList.add('visible');
    //             player = new YT.Player(item.querySelector('lite-youtube').shadowRoot.querySelector('iframe'), {
    //                 events: {
    //                 'onReady': onPlayerReady,
    //                 'onStateChange': onPlayerStateChange
    //                 }
    //             });
    //             videoPlayers[ytId] = player;
    //         })
    //     });
        
    //     document.querySelector('.mediaYTPopin_background').addEventListener('click', (e) => {
    //         e.preventDefault();
    //         scroll.start();
    //         ScrollLock.disable();
    //         popinYT.classList.remove('visible');
    //         popinYT.querySelector('.mediaYTPopin_item.visible').classList.remove('visible');
    //         for (let id in videoPlayers) {
    //             let player = videoPlayers[id];
    //             player.pauseVideo();
    //         }
    //     });

    // }
};

let mmDOM = {
    parent: document.querySelector('.mediaModal'),
    render: document.querySelector('.mediaModal_render'),
    video: document.querySelector('.mediaModal_render_video'),
    close: document.querySelector('.mediaModal_close'),
    closeButton: document.querySelector('.mediaModal_render_video_close'),
};
let mmVideo, mmVideoPlayer;

const initMediaModal = () => {
    document.querySelectorAll('[data-modal]').forEach((button) => {
        let url = button.getAttribute('data-modal');

        button.addEventListener('click', (e) => {
            e.preventDefault();
            openMediaModal(url);
        });
    });
};

const openMediaModal = (url) => {
    scroll.stop();
    ScrollLock.enable();

    mmDOM.parent.style.display = "block";

    mmDOM.parent.classList.add('visible');

    setTimeout(() => {
        mmDOM.render.classList.add('ready');
    }, 300);

    mmVideo = document.createElement("video");
    mmVideo.classList.add('video-js');
    mmVideo.classList.add('vjs-default-skin');
    mmVideo.classList.add('vjs-fluid');
    mmDOM.video.appendChild(mmVideo);

    mmVideoPlayer = videojs(mmDOM.video.querySelector('.video-js'), {
        controls: false,
        autoplay: true,
        nativeTextTracks: true,
        techOrder: ["youtube"],
        sources: [{
            type: "video/youtube",
            src: url
        }],
        youtube: { "ytControls": 2,"customVars": { "cc_load_policy": 1 } }
    });

    setTimeout(() => {
        mmVideoPlayer.play();
    }, 1000);

    initMediaModalEvents();
};

const initMediaModalEvents = () => {
    mmDOM.close.addEventListener('click', closeMediaModal)
    mmDOM.closeButton.addEventListener('click', () => {
        closeMediaModal();
    })
};

const closeMediaModal = () => {
    mmVideoPlayer.pause();
    mmDOM.render.classList.remove('ready');
    setTimeout(() => {
        mmDOM.parent.classList.remove('visible');
        scroll.start();
        ScrollLock.disable();
        
        mmVideoPlayer.dispose();
        let v = mmDOM.video.querySelector('video');
        mmDOM.video.removeChild(v);

        setTimeout(() => {
            mmDOM.parent.style.display = "none";
        }, 1000);
    }, 300);
}; 


const initRedirects = () => {
    if (document.querySelector('.redirectPopin_item') && document.querySelector('.redirectPopin.not-info')) {
        let popinRedirect = document.querySelector('.redirectPopin.not-info');
        redirectElt = document.querySelector('.redirectPopin_item');
        popinRedirect.classList.add('visible');
        redirectElt.classList.add('visible');
        scroll.stop();
        ScrollLock.enable();

        let closeElements = [
            popinRedirect.querySelector('.redirectPopin_background'),
            popinRedirect.querySelector('.redirectPopin_close'),
            redirectElt.querySelector('.redirectPopin_action')
        ];

        closeElements.forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                scroll.start();
                ScrollLock.disable();
                popinRedirect.classList.remove('visible');
            });
        });
    }
};

const initInformationPopin = () => {
    const popinStorageKey = 'popinExpiryTime';
    const twoHoursInMillis = 2 * 60 * 60 * 1000;

    const storedExpiryTime = localStorage.getItem(popinStorageKey);
    const now = new Date().getTime();

    if (storedExpiryTime && now < storedExpiryTime) {
        return;
    }

    if (document.querySelector('.redirectPopin_item') && document.querySelector('.redirectPopin.info')) {
        let popinRedirect = document.querySelector('.redirectPopin.info');
        let redirectElt = document.querySelector('.redirectPopin_item');

        popinRedirect.classList.add('visible');
        redirectElt.classList.add('visible');
        scroll.stop();
        ScrollLock.enable();

        const newExpiryTime = new Date().getTime() + twoHoursInMillis;
        localStorage.setItem(popinStorageKey, newExpiryTime);

        let closeElements = [
            popinRedirect.querySelector('.redirectPopin_background'),
            popinRedirect.querySelector('.redirectPopin_close'),
        ];
        closeElements.forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                scroll.start();
                ScrollLock.disable();
                popinRedirect.classList.remove('visible');
            });
        });
    }
};

let DOM = {};

const closeMenu = () => {
    ScrollLock.disable();
    if (DOM.subNavsParent.querySelector('.subNav.active')) {
        scroll.start();
        ScrollLock.disable();
        DOM.subNavsParent.querySelector('.subNav.active').classList.remove('active');
        if (DOM.mainNav.querySelector('.active')) {
            DOM.mainNav.querySelector('.active').classList.remove('active');
        }
        
        setTimeout(() => {
            DOM.subNavsParent.classList.remove('opened');
        }, 200);

        if (DOM.mobileBackMobile.querySelector('.backMobile.active:not([data-menu="dynamic"]')) {
            DOM.logo.classList.remove('hidden');
            DOM.mobileBackMobile.classList.remove('active');
            DOM.mobileBackMobile.querySelector('.backMobile.active').classList.remove('active');
        }
        if (DOM.dynamicBackMobile.classList.contains("active")) {
            closePopin()
        }
    }
};
const setDynamicBackMobileData = (title,popinId) =>{
    DOM.oldmobileBackMobile = DOM.mobileBackMobile.querySelector('.backMobile.active')
    DOM.oldmobileBackMobile.classList.remove('active')
    DOM.dynamicBackMobile.querySelector("span").innerText = title
    DOM.dynamicBackMobile.classList.add('active')
    DOM.dynamicBackMobile.setAttribute("data-popin",popinId)
}
const removeDynamicBackMobileData = () =>{
    DOM.oldmobileBackMobile.classList.add('active')
    DOM.dynamicBackMobile.querySelector("span").innerText = ""
    DOM.dynamicBackMobile.classList.remove('active')
    DOM.dynamicBackMobile.setAttribute("data-popin","")
    DOM.oldmobileBackMobile = null
}
const closePopin = (popin = null) => {
    let popinId = DOM.dynamicBackMobile.getAttribute("data-popin")
    let popinModal = popin ? popin : document.querySelector(`#${popinId}`)

    if (popinModal) {
    if(window.matchMedia("screen and (min-width: 899px)").matches){
    DOM.openedPopin.state.elements.popper.classList.remove("open")
    DOM.openedPopin.destroy()
    }else{
        removeDynamicBackMobileData()
        popinModal.classList.remove("open")
        popinModal.closest(".subNav").style.transform = ""
    }
    DOM.openedPopin = null
    }

}

const openPopin = (popin) => {

    let title = popin.getAttribute("aria-label")
    let popinId = popin.getAttribute("data-popin")
    let popinModal = document.querySelector(`#${popinId}`)
    if(popinModal && !popinModal.classList.contains('open')){
        popinModal.classList.add("open")
        if(DOM.openedPopin){
            closePopin(DOM.openedPopin)
        }
        if(window.matchMedia("screen and (min-width: 899px)").matches){
            DOM.openedPopin =  createPopper(popin, popinModal,{
            placement: 'auto',
            modifiers: [preventOverflow,
                {
                    name: 'offset',
                    options: {
                    offset: [10, 20],
                    },
                },
                {
                name: 'flip',
                options: {
                allowedAutoPlacements: ['right', 'left'],
                },
                },
                {
                    name: 'preventOverflow',
                    options: {
                    padding: {top:120,bottom:20},
                },
            }
            ],
            });
               document.addEventListener("click",function(e){
            if (!e.target.closest(`#${popinId}`)) {
                closePopin( DOM.openedPopin)
                this.removeEventListener('click', arguments.callee);
            }
            })

        }else{
            popinModal.closest(".subNav").style.transform = "none"
            setDynamicBackMobileData(title,popinId)
        }

    }else{
        closePopin(popinModal)
    }

}

const opendSubmenu = (link) => {
    if (link.classList.contains('hasSubnav')) {
        scroll.stop();
        ScrollLock.enable();

        DOM.subNavsParent.classList.add('opened');
        let subnavId = link.getAttribute('data-menu');
        let subnav = DOM.subNavsParent.querySelector('.subNav[data-menu="' + subnavId + '"]');
        subnav.scrollTop = 0;

        if (DOM.mainNav.querySelectorAll('a.active').length) {
            DOM.mainNav.querySelectorAll('a.active').forEach((l) => {
                l.classList.remove('active');
            });
        }
        if (DOM.navMobile.querySelectorAll('a.active').length) {
            DOM.navMobile.querySelectorAll('a.active').forEach((l) => {
                l.classList.remove('active');
            });
        }

        if (subnav.classList.contains('active')) {
            subnav.classList.remove('active');
            link.classList.remove('active');

            if (DOM.mobileBackMobile.querySelector('.backMobile.active')) {
                DOM.logo.classList.remove('hidden');
                DOM.mobileBackMobile.classList.remove('active');
                DOM.mobileBackMobile.querySelector('.backMobile.active').classList.remove('active');
            }
            
            setTimeout(() => {
                DOM.subNavsParent.classList.remove('opened');
            }, 200);

            scroll.start();
            ScrollLock.disable();
        } else {
            if (DOM.subNavsParent.querySelector('.subNav.active')) {
                DOM.subNavsParent.querySelector('.subNav.active').classList.remove('active');
                setTimeout(() => {
                    subnav.classList.add('active');
                }, 200);
            } else {
                subnav.classList.add('active');
            }

            link.classList.add('active');
            
            DOM.logo.classList.add('hidden');
            DOM.mobileBackMobile.classList.add('active');
            if (DOM.mobileBackMobile.querySelector('.backMobile.active')) {
                DOM.mobileBackMobile.querySelector('.backMobile.active').classList.remove('active');
            }
            DOM.mobileBackMobile.querySelector('.backMobile[data-menu="' + subnavId + '"]').classList.add('active');
        }
    }
};
const initDemoMenu = ()=>{
    const openers = document.querySelectorAll('.demo-open-btn');
    const popinModal = document.querySelector('.demo-popin');
    const closeBtn = document.querySelector('.close-demo-popin')
    if (openers.length > 0) {
        const openDemo =(opener)=>{
            popinModal.classList.add("open")
            if(window.matchMedia("screen and (min-width: 899px)").matches){
                DOM.demoPopin = createPopper(opener, popinModal,{
                    placement: 'auto',
                    modifiers: [preventOverflow,
                        {
                            name: 'offset',
                            options: {
                            offset: [10, 20],
                            },
                        },
                        {
                        name: 'flip',
                        options: {
                        allowedAutoPlacements: ['bottom', 'top'],
                        },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                            padding: {top:120,bottom:20},
                        },
                    }
                    ],
                    });
                    setTimeout(() => {
                        document.addEventListener('click',closeDemo) 
                    }, 200);

            }
        }
        const closeDemo = (e)=>{
            if (window.matchMedia("screen and (min-width: 899px)").matches) {
                if (!e.target.closest('.demo-popin') && !e.target.closest('.demo-open-btn') && !e.target.classList.contains('demo-open-btn')) {
                    popinModal.classList.remove("open")
                        document.removeEventListener('click',closeDemo)
                        openers.forEach(opener=>{
                            opener.style.pointerEvents = "none"
                        })
                        setTimeout(() => {
                            DOM.demoPopin.destroy()
                            openers.forEach(opener=>{
                                opener.style.pointerEvents = "all"
                            })
                        },600)
                }
            }else{
                popinModal.classList.remove("open")
            }
    
        }
        closeBtn.addEventListener('click',closeDemo)
        openers.forEach(opener=>{
            opener.addEventListener('click',()=>{
                openDemo(opener)
            })
        })
    }

}
const initCnxMenu = ()=>{
    const openers = document.querySelectorAll('.cnx-open-btn');
    const popinModal = document.querySelector('.cnx-popin');
    const closeBtn = document.querySelector('.close-cnx-popin')
    if (openers.length > 0) {
        const openCnx =(opener)=>{
            popinModal.classList.add("open")
            if(window.matchMedia("screen and (min-width: 899px)").matches){
                DOM.cnxPopin = createPopper(opener, popinModal,{
                    placement: 'auto',
                    modifiers: [preventOverflow,
                        {
                            name: 'offset',
                            options: {
                            offset: [10, 20],
                            },
                        },
                        {
                        name: 'flip',
                        options: {
                        allowedAutoPlacements: ['bottom', 'top'],
                        },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                            padding: {top:120,bottom:20},
                        },
                    }
                    ],
                    });
                    setTimeout(() => {
                        document.addEventListener('click',closeCnx) 
                    }, 200); 
            }
        }
        const closeCnx = (e)=>{
            if (window.matchMedia("screen and (min-width: 899px)").matches) {
                if (!e.target.closest('.cnx-popin') && !e.target.closest('.cnx-btn') && !e.target.classList.contains('cnx-btn')) {
                    popinModal.classList.remove("open")
                    document.removeEventListener('click',closeCnx)
                    openers.forEach(opener=>{
                        opener.style.pointerEvents = "none"
                    })
                    setTimeout(() => {
                        openers.forEach(opener=>{
                            opener.style.pointerEvents = "all"
                        })
                        DOM.cnxPopin.destroy()
                    }, 600);
                }
            }else{
                popinModal.classList.remove("open")
            }
    
        }
        closeBtn.addEventListener('click',closeCnx)
        openers.forEach(opener=>{
            opener.addEventListener('click',()=>{
                openCnx(opener)
            })
        })
    }

}
const initSearchbar = ()=>{
    const openButton = document.querySelector('button.navSearch')
    const shadow = document.querySelector('.searchBar_shadow')
    const searchBar = document.querySelector('.searchBar')
    const toAnime = document.querySelectorAll('.suggestions .anime')
    const handleOpenSearch = ()=>{
        searchBar.classList.toggle('open')
        openButton.classList.toggle('open')
        if (toAnime.length > 0) {
            anime({
                targets: toAnime,
                opacity:[0,1],
                translateX:[-10,0],
                easing: 'easeOutExpo',
                duration: 1000,
                delay: anime.stagger(200)
            })
        }
    }
    if (openButton) {
        openButton.addEventListener('click',handleOpenSearch)
    }
    if (shadow) {
        shadow.addEventListener('click',handleOpenSearch)
    }
}  
const initMenu = () => {
    DOM.logo = document.querySelector('.navbar_logo');
    DOM.navInner = document.querySelector('.navbar_inner');
    DOM.mainNav = document.querySelector('.mainNav');
    DOM.mainNavRight = document.querySelector('.navbar_right ul');
    DOM.mainNavLinks = DOM.mainNav.querySelectorAll('a');
    DOM.subNavsParent = document.querySelector('.subNavs');
    DOM.subNavs = DOM.subNavsParent.querySelectorAll('.subNav');
    DOM.closeMenu = DOM.subNavsParent.querySelector('.subNavs_close');
    DOM.navMobileToggle = document.querySelector('.navbar_mobileToggle');
    DOM.navMobile = document.createElement('div');

    DOM.navMobile.classList.add('mainMenuMobile')
    DOM.navMobileNav =document.createElement('nav') 
    DOM.navMobileNavBottom = DOM.mainNavRight.cloneNode(true) 
    DOM.navMobileNavBottom.classList.add('mainMenuMobile_bottom')
    DOM.navMobile.appendChild(DOM.navMobileNav)
    let result = ""
    DOM.mainNavLinks.forEach((link,index) => {

        if (index == 0) {
            result += `<ul class="mainMenuMobile_main">`
        }
        result += `<li>${link.outerHTML}</li>`

        if (index == (DOM.mainNavLinks.length -1)) {
            result += `</ul>`

        }

    });
    DOM.navMobileNav.innerHTML = result + DOM.navMobileNavBottom.outerHTML
    document.body.appendChild(DOM.navMobile)
    DOM.navMobileLinks = DOM.navMobile.querySelectorAll('a');
    DOM.mobileBackMobile = document.querySelector('.navbar_backMobileItems');
    DOM.mobileBackMobileItems = DOM.mobileBackMobile.querySelectorAll('.backMobile:not([data-menu="dynamic"])');
    DOM.popIns = document.querySelectorAll("[data-popin]")
    DOM.dynamicBackMobile = DOM.mobileBackMobile.querySelector('[data-menu="dynamic"]')
    // Add current on main nav
    let currentPage = DOM.subNavsParent.querySelector('.current');
    if (currentPage) {
        let parentMenuId = currentPage.closest('.subNav').getAttribute('data-menu');
        DOM.mainNav.querySelector('[data-menu="' + parentMenuId + '"]').classList.add('current');
        DOM.navMobile.querySelector('[data-menu="' + parentMenuId + '"]').classList.add('current');
    }

    // SUBNAVS
    DOM.mainNavLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            if (link.classList.contains('hasSubnav')) {
                e.preventDefault();
            }
            opendSubmenu(link);
        });
    });

    // POPINS
    DOM.popIns.forEach((popin) => {
        popin.addEventListener('click', (e) => {
            e.stopImmediatePropagation()
            openPopin(popin);
        });
    });

    DOM.dynamicBackMobile.addEventListener('click',() => { closePopin(); })

    DOM.closeMenu.addEventListener('click', () => { closeMenu(); });

    // MOBILE
    DOM.navMobileToggle.addEventListener('click', () => {
        if (DOM.navMobileToggle.classList.contains('opened')) {
            DOM.navMobileToggle.classList.remove('opened');
            DOM.navMobile.classList.remove('visible');
            closeMenu();
        } else {
            DOM.navMobileToggle.classList.add('opened');
            DOM.navMobile.classList.add('visible');
            ScrollLock.enable();
        }
    });

    DOM.navMobileLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            if (link.classList.contains('hasSubnav')) {
                e.preventDefault();
            }
            opendSubmenu(link);
        });
    });

    DOM.mobileBackMobileItems.forEach((link) => {
        link.addEventListener('click', (e) => {
            closeMenu();
        });
    });

};
const initToaster = () =>{
    const lastToaster = parseInt(localStorage.getItem('silae-toaster') ?? 1, 10),
    nowDate = Date.now();
    var closeButton = document.querySelector('.toaster button')
    var toaster = document.querySelector('.toaster')
    if (toaster){
        const updateHeight =  ()=> {

            /* Every hour */
            if (lastToaster && lastToaster + 1000 * 60 * 60 < nowDate) {
                var toaster = document.querySelector('.toaster')
                if (!toaster.classList.contains('closed')) {
                    toaster.style.maxHeight = "500px"
                    var height = toaster.querySelector('.toaster__content').getBoundingClientRect().height + 6 + 'px'
                    document.documentElement.style.setProperty('--toaster-height', height);
                }
            }else{
                var toaster = document.querySelector('.toaster')
                toaster.style.maxHeight = "0"
                toaster.classList.add('closed')
                document.documentElement.style.setProperty('--toaster-height', null);
            }
        }
        const closeToaster = ()=>{
            var toaster = document.querySelector('.toaster')
            toaster.style.maxHeight = "0"
            toaster.classList.add('closed')
            document.documentElement.style.setProperty('--toaster-height', null);
            localStorage.setItem('silae-toaster', nowDate);
        }
        updateHeight();
        closeButton.addEventListener('click',closeToaster)
        window.addEventListener('resize',updateHeight)
    }

}
const initTextareas = () => {
    if (!document.querySelector('.page-template-tpl-product-finder')) {
        const tx = document.getElementsByTagName("textarea");
        for (let i = 0; i < tx.length; i++) {
            tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
            tx[i].addEventListener("input", OnInput, false);
        }

        function OnInput() {
            this.style.height = "auto";
            this.style.height = (this.scrollHeight) + "px";
        }
    }
};

const initMobileFilter = (callback = null, reset = null) => {
    let url = new URL(window.location);
    let button = document.querySelector('.header_filtersMobileButton');
    let render = document.querySelector('.header_filtersMobileButton_render > span');
    let renderDefault = 'Filtrer par';
    let renderSearch = 'Modifier';
    let filtersWrap = document.querySelector('.mobileFilters');
    let filtersClose = filtersWrap.querySelector('.mobileFilters_close');
    let filtersFields = filtersWrap.querySelectorAll('.mobileFilters_field');
    let filtersValidate = filtersWrap.querySelector('.mobileFilters_action');
    if (button) {
    button.addEventListener('click', (e) => {
        filtersWrap.classList.add('active');
    });

    filtersClose.addEventListener('click', (e) => {
        filtersWrap.classList.remove('active');
    });

    filtersValidate.addEventListener('click', (e) => {
        filtersWrap.classList.remove('active');
        url.searchParams.delete('pg');
        Utils.updateUrl(url.href);

        if (reset) {
            reset();
        }

        if (callback) {
            callback();
        }
    });

    if (url.search == '' || url.searchParams.has('search')) {
        render.innerHTML = renderDefault;
    } else {
        render.innerHTML = renderSearch;
    }


    filtersFields.forEach((fieldElt) => {
        let field = fieldElt.getAttribute('data-field');
        let isMultiple = fieldElt.hasAttribute('data-field-multiple');
        let items = fieldElt.querySelectorAll('.mobileFilters_field_list a');

        items.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let values = [];
                let value = link.getAttribute('data-value');

                if (isMultiple) {
                    if (link.classList.contains('active')) {
                        link.classList.remove('active');
                    } else {
                        link.classList.add('active');
                    }
                } else {
                    if (fieldElt.querySelector('.mobileFilters_field_list .active')) {
                        fieldElt.querySelector('.mobileFilters_field_list .active').classList.remove('active');
                    }
                    link.classList.add('active');
                }

                if (fieldElt.querySelectorAll('.mobileFilters_field_list .active')) {
                    fieldElt.querySelectorAll('.mobileFilters_field_list .active').forEach((l) => {
                        values.push(l.getAttribute('data-value'));
                    })
                }

                url.searchParams.delete('pg');

                if (value == 'all') {
                    url.searchParams.delete(field);
                    if (fieldElt.querySelectorAll('.mobileFilters_field_list .active')) {
                        fieldElt.querySelectorAll('.mobileFilters_field_list .active').forEach((l) => {
                            l.classList.remove('active');
                        })
                    }
                    link.classList.add('active');
                } else {
                    fieldElt.querySelector('[data-value="all"]').classList.remove('active');
                    url.searchParams.set(field, values.join(','));
                }

                if (url.search == '') {
                    render.innerHTML = renderDefault;
                } else {
                    render.innerHTML = renderSearch;
                }

                Utils.updateUrl(url.href);
            });
        })
    });
    
    }

};

const initFaqMobile = () => {
    console.log('initFaqMobile');
    let button = document.querySelector('.header_filtersMobileButton');
    let filtersWrap = document.querySelector('.mobileFilters');
    let filtersClose = filtersWrap.querySelector('.mobileFilters_close');
    let filtersFields = filtersWrap.querySelectorAll('.mobileFilters_field');

    button.addEventListener('click', (e) => {
        filtersWrap.classList.add('active');
    });

    filtersClose.addEventListener('click', (e) => {
        filtersWrap.classList.remove('active');
    });

    filtersFields.forEach((fieldElt) => {
        let items = fieldElt.querySelectorAll('.mobileFilters_field_list a');

        items.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let category = link.getAttribute('data-category');
                let elt = document.querySelector('.faqCategory[data-category="' + category + '"]');
                filtersWrap.classList.remove('active');
                scrollTo(elt, -50);
            });
        })
    });
    
};

const initLotties = () => {
    document.querySelectorAll('.lottie').forEach((elt) => {
        let url = elt.getAttribute('data-url');
        if (url) {
            let anim = lottie.loadAnimation({
                container: elt,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: url
            });

            anim.addEventListener('data_ready', () => {
                if (scroll) {
                    scroll.update();
                }
            });
        }
    });
};

const recreateVideoHeader = () => {
    if (document.querySelector('.header') && document.querySelector('.header').querySelector('.media video')) {
        let header = document.querySelector('.header');
        let vid = header.querySelector('.media video');

        let wrapper = header;
        let canvas = header.querySelector('.media canvas');
        let ctx = canvas.getContext('2d');

        let ratio = window.devicePixelRatio || 1;
        let vidWidth;
        let vidHeight;

        vid.addEventListener('loadedmetadata', function (e) {
            // console.log('onloadedmetadata');
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            drawingLoop();

            //resize scale for comparison
            vid.style.transform = `scale(1)`;
        });

        vid.addEventListener('loadeddata', function (e) {
            // console.log('onloadeddata');
            // setVideoBgColor(vid, wrapper);
            vid.play();
        });

        function drawingLoop() {
            requestId = window.requestAnimationFrame(drawingLoop)

            ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                0, 0, canvas.width, canvas.height); // destination rectangle);
        }

        function setVideoBgColor(vid, backgroundElement) {
            // draw first four pixel of video to a canvas
            // then get pixel color from that canvas
            let canvas = document.createElement("canvas");
            canvas.width = 8;
            canvas.height = 8;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(vid, 0, 0, 8, 8);

            let p = ctx.getImageData(0, 0, 8, 8).data;
            //dont take the first but fourth pixel [r g b]
            backgroundElement.style.backgroundColor = "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
        }

        window.onresize = function (event) {
            //resize scale for comparison
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            //redraw canvas after resize
            ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                0, 0, canvas.width, canvas.height); // destination rectangle);

            //resize scale for comparison
            vid.style.transform = `scale(1)`;
        };


        //add src
        vid.src = vid.getAttribute('data-src');
        vid.play();
    }
    if (document.querySelector('.wysiwyg_media') && document.querySelector('.wysiwyg_media').querySelector('.media video')){
        const medias = document.querySelectorAll('.wysiwyg_media')
        
        medias.forEach(media=>{
            let vid = media.querySelector('.media video');
            let canvas = media.querySelector('.media canvas');
            let ctx = canvas.getContext('2d');
            let ratio = window.devicePixelRatio || 1;
            let vidWidth;
            let vidHeight;
    
            vid.addEventListener('loadedmetadata', function (e) {
                // console.log('onloadedmetadata');
                vid.style.transform = `scale(${ratio})`;
    
                vidWidth = vid.videoWidth;
                vidHeight = vid.videoHeight;
    
                canvas.width = vid.offsetWidth * ratio;
                canvas.height = vid.offsetHeight * ratio;
    
                canvas.style.width = vid.offsetWidth + "px";
                canvas.style.height = vid.offsetHeight + "px";
    
                drawingLoop();
    
                //resize scale for comparison
                vid.style.transform = `scale(1)`;
            });
    
            vid.addEventListener('loadeddata', function (e) {
                // console.log('onloadeddata');
                // setVideoBgColor(vid, wrapper);
                vid.play();
            });
    
            function drawingLoop() {
                requestId = window.requestAnimationFrame(drawingLoop)
    
                ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                    0, 0, canvas.width, canvas.height); // destination rectangle);
            }
    
            function setVideoBgColor(vid, backgroundElement) {
                // draw first four pixel of video to a canvas
                // then get pixel color from that canvas
                let canvas = document.createElement("canvas");
                canvas.width = 8;
                canvas.height = 8;
    
                let ctx = canvas.getContext("2d");
                ctx.drawImage(vid, 0, 0, 8, 8);
    
                let p = ctx.getImageData(0, 0, 8, 8).data;
                //dont take the first but fourth pixel [r g b]
                backgroundElement.style.backgroundColor = "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
            }
    
            window.onresize = function (event) {
                //resize scale for comparison
                vid.style.transform = `scale(${ratio})`;
    
                vidWidth = vid.videoWidth;
                vidHeight = vid.videoHeight;
    
                canvas.width = vid.offsetWidth * ratio;
                canvas.height = vid.offsetHeight * ratio;
    
                canvas.style.width = vid.offsetWidth + "px";
                canvas.style.height = vid.offsetHeight + "px";
    
                //redraw canvas after resize
                ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                    0, 0, canvas.width, canvas.height); // destination rectangle);
    
                //resize scale for comparison
                vid.style.transform = `scale(1)`;
            };
            //add src
            vid.src = vid.getAttribute('data-src');
            vid.play();
        })
    }
};

const initProductFinder = () => {
    const productFinder = document.querySelector('.product__container')
    if (productFinder && !/sended/.test(window.location)) {
        const progressCurrent = document.querySelector('.product__progress-current')
        const progress = document.querySelector('.product__progress')  
        const questions = document.querySelectorAll('.product__question')
        const questionsContainer = productFinder.querySelector('.product__questions')
        const previousBtn = document.querySelector('.product__previous-btn')
        const nextBtn = document.querySelector('.product__next-btn')
        const subChoices = document.querySelector('.product__question__answer-sub-choices')
        const productWrapper = document.querySelector('.product__wrapper')
        const result = productFinder.querySelector('.product__result')
        const resultTitle = productFinder.querySelector('.product__result-title')
        if(window.matchMedia("screen and (max-width: 930px)").matches){
            const cards = productFinder.querySelectorAll('.product__result__card')
            cards.forEach(card=>{
                card.querySelector('.product__result__card-title').addEventListener('click',(e)=>{
                    if (e.target == e.currentTarget) {
                        card.classList.add('open')
                        card.querySelector('button').addEventListener('click',(e2)=>{
                            card.classList.remove('open')
                       })
                    }
                })
            })
        }
        const setAnswer = (data,question)=>{
            question.setAttribute("data-answered",data)
        }
        const setTreeValue = (data,question)=>{
            question.setAttribute("data-tree-value",data)
        }
        const checkSingleAnswer = (question)=>{
           let active =  question.querySelector('.product__question__answer.active')
            if (active) {
                active.classList.remove('active')
            }
        }
        const checkMultipleAnswer = (question,target)=>{
           let empty =  question.querySelector('.no-icon.active')
            if (empty && target !==  empty) {
                empty.classList.remove('active')
            }else if (empty && target ==  empty){
                question.querySelectorAll('.product__question__answer:not(.no-icon)').forEach(answer=>{
                    answer.classList.remove('active')
                })
            }
        }
        const getSolution = ()=>{
            let data = []
            let isClient = false;
            questions.forEach((question,index)=>{
                let answered = JSON.parse(question.getAttribute('data-answered'))
                data.push(answered)
            })
            if (data.includes('is-client')) {
                isClient = true
            }

            if (data.includes('my-silae') && data.includes('rhsuite')) {
                data.splice(data.indexOf('my-silae'),1);
            }
            if (isClient && data.includes('silae-paie')) {

                data.splice(data.indexOf('silae-paie'),1);
            }
            data = data.filter(item=> item != null)
            data = data.filter((item,index) => data.indexOf(item) === index)
            const amount = productFinder.querySelector('.product__result_ammount')




            if (data.length < 2  && data[0] === "my-silae") {
                data[1] = data[0]
                data[0] = "silae-paie"
            }
            data[0] = `#${data[0]}`
            if (data.length > 1) {
                amount.innerText = amount.getAttribute('data-text').replace('$amount',data.length)
            }else{
                amount.innerText = amount.getAttribute('data-text-single')
            }
           return data.join(', #')
        }
        const applyPopper = (answers)=>{
                answers.forEach(answer=>{
                    let tooltipBtn = answer.querySelector('.product__question__answer-info')
                    let tooltip = answer.querySelector('.product__question__answer-info-tooltip')
                    if(tooltipBtn){
                        const clickFunction = ()=>{
                            tooltip.closest('.product__question__answer').classList.add('tooltip-open')
                            tooltip.classList.add('opened')
                            setTimeout(() => {
                                window.addEventListener('click',(e)=>{
                                    if(e.target != tooltip && tooltip.classList.contains('opened')){
                                        tooltip.closest('.product__question__answer').classList.remove('tooltip-open')
                                        tooltip.classList.remove('opened')
                                    }
                                },{ once: true })
                            }, 50);
                        }
                        const hoverFunction = ()=>{
                            tooltip.closest('.product__question__answer').classList.add('tooltip-open')
                            tooltip.classList.add('opened')
                            setTimeout(() => {
                                tooltipBtn.addEventListener('mouseleave',(e)=>{
                                        tooltip.closest('.product__question__answer').classList.remove('tooltip-open')
                                        tooltip.classList.remove('opened')
                                },{ once: true })
                            }, 50);
                        }
                        if(window.matchMedia("screen and (max-width: 580px)").matches){
                            tooltipBtn.addEventListener('click',clickFunction)
                        }else{
                            tooltipBtn.addEventListener('mouseenter',hoverFunction)
                        }
                        const popin = createPopper(tooltipBtn, tooltip,{
                            placement: 'bottom',  modifiers: [
                                {
                                    name: 'preventOverflow',
                                    options: {
                                        altAxis: true,
                                        padding: 5, 
                                    },
                                },
                                {
                                    name: 'flip',
                                    options: {
                                        fallbackPlacements: ['top'],
                                    },
                                },
                                {
                                    name: 'offset',
                                    options: {
                                        offset: [0, 10],
                                    },
                                },
                            ],
                            })
                    const cleanEvents = ()=>{
                        tooltipBtn.removeEventListener('click',clickFunction) 
                        tooltip.classList.remove('opened')
                        popin.destroy()
                    }
                    setTimeout(() => {
                        productFinder.addEventListener('next-question',cleanEvents)
                        productFinder.addEventListener('previous-question',cleanEvents)
                    }, 50);

                    }
                })

        }
        const preventMultipleClick = ()=>{
            productWrapper.style.pointerEvents = "none"
        }
        const fillForm = () => {
            const solution = document.querySelector('.form-solution')
            const sirh = document.querySelector('.form-sirh')
            const bdese = document.querySelector('.form-bdese')
            const expense = document.querySelector('.form-expense')
            const gta = document.querySelector('.form-gta')
            const shortContract = document.querySelector('.form-short-contract')
            const size = document.querySelector('.form-size')
            const type = document.querySelector('.form-company-type')
            const fields = [size,type,shortContract,gta,expense,bdese,sirh]
            questions.forEach((question,index)=>{
                if (index != questions.length - 1) {
                    let value = JSON.parse(question.getAttribute('data-tree-value'))

                    if(Array.isArray(value)){
                        const options = Array.from(fields[index].querySelectorAll('option'))
                        value.forEach(value=>{
                            options.find(c => c.value == value).selected = true;
                        })
                    }else{
                        fields[index].value = value
                    }
                }
            })
            document.querySelector('.sirh-form').value = sirh.value
            let names = "";
            productFinder.querySelectorAll(getSolution()).forEach(element=> {
                names+= ' ' + element.querySelector('.product__result__card-title').innerText

            })
            solution.value = names.trim()
        }

        if(questions.length){
            questions.forEach(question =>{
                let answers = question.querySelectorAll('.product__question__answer')
                answers.forEach(answer => {
                answer.addEventListener('click',(e)=>{
                    if(e.target == e.currentTarget){
                        if (e.currentTarget.classList.contains('single-choice') ) {
                            preventMultipleClick()
                            setAnswer(e.currentTarget.getAttribute("value"),question)
                            setTreeValue(e.currentTarget.getAttribute("tree-value"),question)
                            checkSingleAnswer(question)
                            answer.classList.toggle('active')
                            setTimeout(() => {
                                productFinder.dispatchEvent(new CustomEvent('next-question'))
                            }, 500); 
                        }else if (e.currentTarget.classList.contains('has-sub-choices') ){
                            checkSingleAnswer(question)
                            answer.classList.toggle('active')
                        }else if (e.currentTarget.classList.contains('with-sub-choices') ){

                            preventMultipleClick()
                            setAnswer(e.currentTarget.getAttribute("value"),question)
                            setTreeValue(e.currentTarget.getAttribute("tree-value"),question)
                            checkSingleAnswer(question)
                            answer.classList.toggle('active')
                            setTimeout(() => {
                                productFinder.dispatchEvent(new CustomEvent('next-question'))
                            }, 500); 
                        }else if (e.currentTarget.classList.contains('multiple-choices') ){
                                answer.classList.toggle('active')
                                checkMultipleAnswer(question,e.currentTarget)
                        }

                    }
                })
                })
            })
        }
        previousBtn.addEventListener('click',()=>{
            preventMultipleClick()
            productFinder.dispatchEvent(new CustomEvent('previous-question'))
        })
        nextBtn.addEventListener('click',(e)=>{
            preventMultipleClick()
            let question = e.target.closest('.product__question')
            let answers = question.querySelectorAll('.active')
            let dataValue = null
            let dataTree = []
            answers.forEach(answer=>{
                dataValue =  JSON.parse(answer.getAttribute('value'))
                dataTree =  dataTree.concat(JSON.parse(answer.getAttribute('tree-value')))
            })
            dataValue = JSON.stringify(dataValue)
            dataTree = JSON.stringify(dataTree)

            setAnswer(dataValue,question)
            setTreeValue(dataTree,question)
            productFinder.dispatchEvent(new CustomEvent('next-question'))
        })
        subChoices.addEventListener('change',(e)=>{
            preventMultipleClick()
            let question =  e.target.closest('.product__question')
            let answer =  e.target.closest('.product__question__answer')
            setAnswer(answer.getAttribute('tree-value') ,question)
            setTreeValue(e.target.value,question)
            productFinder.dispatchEvent(new CustomEvent('next-question'))
        })
        const animateIn  = (target)=> {
                const answers = target.querySelectorAll('.product__question__answer')
                const title = target.querySelector('.product__question-title')
                const tl = anime.timeline({
                    autoplay: false,
                    easing:"linear"
                });
                tl.add({
                    targets: answers,
                    translateY: [20,0],
                    opacity:[0,1],
                    duration:200,
                    delay: anime.stagger(50)
                })
                tl.add({
                    targets: title,
                    translateY: [10,0],
                    opacity:[0,1],
                    duration:500,
                },100)
                tl.play()
                tl.finished.then(()=>{
                    answers.forEach(answer=>{
                        answer.style = ""
                    })
                    applyPopper(answers)
                    productWrapper.style.pointerEvents = 'all'
                })
                return tl
        }
        const animateOut  = (target)=> {
                const answers = target.querySelectorAll('.product__question__answer')
                const title = target.querySelector('.product__question-title')
                const tl = anime.timeline({
                    autoplay: false,
                    easing:"linear",
                });
                tl.add({
                    targets: answers,
                    translateY: [0,-20],
                    opacity:[1,0],
                    duration:200,
                    delay: anime.stagger(50)
                })
                tl.add({
                    targets: title,
                    translateY: [0,-10],
                    opacity:[1,0],
                    duration:500,
                },100)
                tl.play()
                return tl
        }
        const initialAnimation = ()=>{
            animateOut(questions[0]) 
            setTimeout(() => {
                animateIn(questions[0]) 
            }, 1400);
        }
        initialAnimation()
        const showResults =() =>{
            let element = getSolution()
            fillForm()
            const solutions = productFinder.querySelectorAll(element)
            solutions.forEach((element,index) => {
                element.style.display = 'block'
                if (index != solutions.length -1) {
                    element.nextElementSibling.style.display = "flex"
                }
            });
            productFinder.querySelector('.product__form').style.display = 'block'
            questionsContainer.style.display = 'none'
            progress.style.display = 'none'
            result.style.display = 'block'
            resultTitle.style.display = 'block'
            productWrapper.style.display = 'block'
            progressCurrent.innerText = parseInt(progressCurrent.innerText) + 1
            productWrapper.style.pointerEvents = 'all'
        }
        const pushNextQuestion = ()=>{
            let animation = animateOut(questions[progressCurrent.innerText - 1])
            animation.finished.then(()=>{
                questions[progressCurrent.innerText - 1].style.display = 'none'
                if(questions[progressCurrent.innerText - 1].getAttribute('data-skip') && questions[progressCurrent.innerText - 1].getAttribute('data-skip') == questions[progressCurrent.innerText - 1].getAttribute('data-tree-value')){
                    progressCurrent.innerText = parseInt(progressCurrent.innerText) + 1
                }
                questions[progressCurrent.innerText].style.display = 'block'
                animateIn(questions[progressCurrent.innerText])
                questions[progressCurrent.innerText].style.height = `${questions[progressCurrent.innerText].scrollHeight}px`
                progressCurrent.innerText = parseInt(progressCurrent.innerText) + 1
            })
            previousBtn.style.display = 'flex'
        }
        const hideResults = ()=>{
            let element = getSolution()
            productFinder.querySelector(element).style.display = 'none'
            productFinder.querySelector('.product__form').style.display = 'none'
            questionsContainer.style.display = 'flex'
            progress.style.display = 'flex'
            productWrapper.style.display = 'flex'
            result.style.display = 'none'
            resultTitle.style.display = 'none'
            progressCurrent.innerText = parseInt(progressCurrent.innerText) - 1
            animateIn(questions[progressCurrent.innerText - 1])
        }
        const pushPreviousQuestion=()=>{
            progressCurrent.innerText = parseInt(progressCurrent.innerText) - 1
            let animation = animateOut(questions[progressCurrent.innerText])
            animation.finished.then(()=>{
                questions[progressCurrent.innerText].style.display = 'none'
                if(questions[progressCurrent.innerText - 2].getAttribute('data-skip') && questions[progressCurrent.innerText - 2].getAttribute('data-skip') == questions[progressCurrent.innerText - 2].getAttribute('data-tree-value')){
                    progressCurrent.innerText = parseInt(progressCurrent.innerText) - 1
                }
                questions[progressCurrent.innerText - 1].style.display = 'block'
                questions[progressCurrent.innerText - 1].style.height = `${questions[progressCurrent.innerText - 1].scrollHeight}px`
                animateIn(questions[progressCurrent.innerText - 1])
            })
}       
        productFinder.addEventListener('next-question',()=>{
            if(progressCurrent.innerText < questions.length){
                pushNextQuestion()
            }else if(progressCurrent.innerText == questions.length){
                showResults()
            }
            scroll.update();
        })
        productFinder.addEventListener('previous-question',()=>{
            if(progressCurrent.innerText > questions.length){
                hideResults()
            } else if(progressCurrent.innerText > 1){
                pushPreviousQuestion()
            }
            if(progressCurrent.innerText == 1){
                previousBtn.style.display = 'none'
            }
            scroll.update();
        })
        const countryNumber = document.querySelector('.phone-select')
        const number = document.querySelector('#phone')
        const alreadyClient = document.querySelector(".already-client")
        const client = document.querySelectorAll(".client")
        const submitButton = document.querySelector('.submit-button')
        const form = document.querySelector('.product__form')
        submitButton.addEventListener('click',(e)=>{
            e.preventDefault()
            if (form.checkValidity()) {
                $.ajax({
                    type: 'POST',
                    url: form.getAttribute('action'),
                    data: $('.product__form').serialize() ,
                    dataType : 'json', 
                    complete: function () {
                        window.location = window.location + "?sended"
                    }
                }); 
            }else{
                form.querySelectorAll('[required]').forEach(field=>{
                    if (!field.getAttribute('minlength') && !field.value || (field.type == "checkbox" && !field.checked)) {
                        field.closest('.js-form-col').classList.add('error')
                    } else if(field.getAttribute('minlength') && !(field.value.length > 5 && field.value.length < 40)){
                        field.closest('.js-form-col').classList.add('error')
                    }
                    else{
                        field.closest('.js-form-col').classList.remove('error')
                    }
                })
            }


        })
        client.forEach((input)=>{ 
            if(input.checked){
                alreadyClient.value = input.value
            }
            input.addEventListener('change',()=>{
                if(input.checked){
                    alreadyClient.value = input.value
                }
            })
        })
        
        if(countryNumber && number){
            countryNumber.querySelectorAll('option').forEach((option,index)=>{
            if (index == 0) {
                return
            }
            option.innerText = option.innerText.replace(option.innerText.substring(option.innerText.indexOf("(")),"") 
            })
            countryNumber.addEventListener('change',()=>{
            number.value = countryNumber.value.substring(countryNumber.value.indexOf("(") + 1,countryNumber.value.lastIndexOf(")"))
            })
        }
    }else if(/sended/.test(window.location)){
        document.querySelector('.product__wrapper').style.display = 'none'
        document.querySelector('.product__progress').style.display = 'none'
        document.querySelector('.product__success').style.display = 'flex'
    }

};

// ----- SUBMENU HOVER EFFECT -------------------------
const initSubMenuEffect = () => {
    document.querySelectorAll('.subMenu_solutions_popin,.product_finder').forEach((link) => {
        

        
        let domBubble = document.createElement('div');
        domBubble.classList.add('link_circle_bubble');

        let domCircle = document.createElement('div');
        domCircle.appendChild(domBubble);
        domCircle.classList.add('link_circle');

        link.appendChild(domCircle);

        let circle = link.querySelector('.link_circle');
        let bubble = link.querySelector('.link_circle_bubble');

        if (!circle || !bubble) return;

        let buttonBounds = link.getBoundingClientRect();

        link.addEventListener('mouseenter', (e) => {
            buttonBounds = link.getBoundingClientRect();
            let posX = e.clientX - buttonBounds.left;
            let posY = e.clientY - buttonBounds.top;
            circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';

            bubble.style.transform = 'scale(1)';
            bubble.style.opacity = '1';
        });

        link.addEventListener('mouseleave', () => {
            bubble.style.transform = 'scale(0)';
            bubble.style.opacity = '0';
        });
    })
};


// ----- BUTTONS EFFECT -------------------------
const initButtons = () => {
    document.querySelectorAll('.button').forEach((button) => {
        
        button.innerHTML = '<span>' + button.innerHTML + '</span>';
        
        let domBubble = document.createElement('div');
        domBubble.classList.add('button_circle_bubble');

        let domCircle = document.createElement('div');
        domCircle.appendChild(domBubble);
        domCircle.classList.add('button_circle');

        button.appendChild(domCircle);

        let circle = button.querySelector('.button_circle');
        let bubble = button.querySelector('.button_circle_bubble');

        if (!circle || !bubble) return;

        let buttonBounds = button.getBoundingClientRect();

        button.addEventListener('mouseenter', (e) => {
            buttonBounds = button.getBoundingClientRect();
            let posX = e.clientX - buttonBounds.left;
            let posY = e.clientY - buttonBounds.top;
            circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';

            bubble.style.transform = 'scale(1)';
            bubble.style.opacity = '1';
        });

        button.addEventListener('mouseleave', () => {
            bubble.style.transform = 'scale(0)';
            bubble.style.opacity = '0';
        });
    })
};

const page = () => {
    scroll.start();
    ScrollLock.disable();
    initToaster()
    loadImages();
    initModules();
    initMenu();
    initSearchbar();
    initDemoMenu();
    initCnxMenu();
    initMediaModal();
    initRedirects();
    initInformationPopin();
    initLotties();
    initButtons();
    initSubMenuEffect()
    recreateVideoHeader();
    initProductFinder();
    setTimeout(() => {
        initTextareas();
        scroll.update();
    }, 1000);

    let url = new URL(window.location);

    document.querySelectorAll('[data-scrollto]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            let attr = link.getAttribute('data-scrollto');
            let elt;
            if (attr) {
                elt = document.querySelector(attr);
            }
            if (elt) {
                scrollTo(elt);
            }
        });
    });

    if (document.querySelectorAll('[data-clipboard-text]').length) {
        document.querySelectorAll('[data-clipboard-text]').forEach((link) => {
            new ClipboardJS(link);
        });
    }

    if (document.querySelectorAll('.faqCategory_title').length) {
        document.querySelectorAll('.faqCategory_title').forEach((link) => {
            link.addEventListener('click', (e) => {
                if (link.getAttribute('data-category')) {
                    window.location.hash = "#" + link.getAttribute('data-category');

                    let tooltip = link.querySelector('.tooltip');
                    let tooltipDefault = tooltip.getAttribute('data-state-default');
                    let tooltipClicked = tooltip.getAttribute('data-state-clicked');

                    tooltip.innerHTML = tooltipClicked;
                    setTimeout(() => {
                        tooltip.innerHTML = tooltipDefault;
                    }, 2000);
                }
            })
        });
    }


    ////////////////////////////////////////////
    /// CAS CLIENTS                        /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-casclient')) {
        let casclientsPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;
        let respirationsData = $('.casclientsList').attr('data-respirations');

        const resetCasclientsVars = () => {
            casclientsPaged = 1;
        };

        let doCasclientsAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.casclientsList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.casclientsList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'casclients_ajax',
                    paged: casclientsPaged,
                    offset: 1,
                    category: url.searchParams.get('category'),
                    respirations: respirationsData
                },
                success: function (result) {
                    if (append) {
                        $('.casclientsList').find('.loadMoreButton').remove();
                        $('.casclientsList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.casclientsList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initCasclientsLoadMore();
                    loadImages();
                    scroll.update();
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };

        $('.casclientsCategories').find('a').on('click', function (e) {
            e.preventDefault();

            casclientsPaged = 1;
            url.searchParams.delete('pg');

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') != 'all') {
                    $(this).removeClass('active');
                }
            } else {
                $('.casclientsCategories .active').removeClass('active');
                $(this).addClass('active');
            }

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') == 'all') {
                    url.searchParams.delete('category');
                } else {
                    url.searchParams.set('category', $(this).attr('data-value'));
                }
            } else {
                url.searchParams.delete('category');
            }

            Utils.updateUrl(url.href);
            doCasclientsAjax();
        });

        initMobileFilter(doCasclientsAjax, resetCasclientsVars);
    

        let initCasclientsLoadMore = () => {
            $('.casclientsList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                casclientsPaged++;
                url.searchParams.set('pg', casclientsPaged);
                Utils.updateUrl(url.href);
                doCasclientsAjax(true);
            });
        };

        initCasclientsLoadMore();
    }


    ////////////////////////////////////////////
    /// PARTENAIRES                        /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-partners')) {
        let partenairesPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;
        
        const resetPartenairesVars = () => {
            partenairesPaged = 1;
        };


        $('.partnersFilters_reset').on('click', function (e) {
            e.preventDefault();

            url.searchParams.delete('region');
            url.searchParams.delete('type');
            url.searchParams.delete('solution');
            url.searchParams.delete('pg');
            partenairesPaged = 1;

            $('.partnersFilters_reset').hide();

            $('.partnersFilters_select').each(function(){
                $(this).val('all');
            });

            document.querySelectorAll('.styledMultipleSelect').forEach((ms) => {
                ms.querySelector('.styledMultipleSelect_value').classList.remove('filled');
                ms.querySelector('.styledMultipleSelect_box').querySelectorAll('a.active').forEach((link) => {
                    link.classList.remove('active');
                });
                ms.querySelector('.styledMultipleSelect_box').querySelector('a[data-value="all"]').classList.add('active');
            });

            Utils.updateUrl(url.href);
            doPartenairesAjax();
        });

        let doPartenairesAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.partenairesList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.partenairesList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'partenaires_ajax',
                    paged: partenairesPaged,
                    offset: 1,
                    region: url.searchParams.get('region'),
                    solution: url.searchParams.get('solution'),
                    type: url.searchParams.get('type')
                },
                success: function (result) {
                    if (append) {
                        $('.partenairesList').find('.loadMoreButton').remove();
                        $('.partenairesList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.partenairesList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initPartenairesLoadMore();
                    loadImages();
                    scroll.update();
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };

        initMobileFilter(doPartenairesAjax, resetPartenairesVars);

        let initPartenairesLoadMore = () => {
            $('.partenairesList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                partenairesPaged++;
                url.searchParams.set('pg', partenairesPaged);
                Utils.updateUrl(url.href);
                doPartenairesAjax(true);
            });
        };

        initPartenairesLoadMore();

        let initMultiselect = (selector, param, labels = {}) => {
            let msParent = document.querySelector(selector);
            let msValue = msParent.querySelector('.styledMultipleSelect_value');
            let msBox = msParent.querySelector('.styledMultipleSelect_box');
            let msRender = msValue.querySelector('.styledMultipleSelect_value_render');
    
            msValue.addEventListener('click', (e) => {
                e.preventDefault();
                if (!msBox.classList.contains('visible')) {
                    scroll.stop();
                    msBox.classList.add('visible');
                    msBox.scrollTop = 0;
                    document.addEventListener("click", (event) => {
                        e.preventDefault();
                        const isClickInside = msParent.contains(event.target);
                    
                        if (!isClickInside) {
                            msBox.classList.remove('visible');
                            scroll.start();
                        }
                    });
                }
            });
    
            msBox.querySelectorAll('a').forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (link.getAttribute('data-value') == 'all') {
                        if (msBox.querySelectorAll('a.active')) {
                            msBox.querySelectorAll('a.active').forEach((l) => {
                                l.classList.remove('active');
                            });
                        }
                        link.classList.add('active');
                        msValue.classList.remove('filled');
                        url.searchParams.delete(param);
                    } else {
                        msBox.querySelector('a[data-value="all"]').classList.remove('active');
    
                        if (link.classList.contains('active')) {
                            link.classList.remove('active');
                        } else {
                            link.classList.add('active');
                        }
    
                        let values = [];
    
                        if (msBox.querySelectorAll('a.active')) {
                            msBox.querySelectorAll('a.active').forEach((l) => {
                                values.push(l.getAttribute('data-value'));
                            });
                        }
    
                        if (values.length > 0) {
                            url.searchParams.set(param, values.join(','));
                            let render = values.length > 1 ? labels.multiple : labels.single;
                            msValue.classList.add('filled');
                            msRender.innerHTML = values.length + ' ' + render;
                            $('.partnersFilters_reset').show();
                        } else {
                            msValue.classList.remove('filled');
                            url.searchParams.delete(param);
                        }
                    }
    
                    url.searchParams.delete('pg');
                    partenairesPaged = 1;
                    
                    Utils.updateUrl(url.href);
                    doPartenairesAjax();
    
                });
            });
    
            // Init
            let r = url.searchParams.get(param);
            if (r) {
                let values = r.split(',');
                if (values.length > 0) {
                    let render = values.length > 1 ? labels.multiple : labels.single;
                    msValue.classList.add('filled');
                    msRender.innerHTML = values.length + ' ' + render;
                }
            }
        }

        initMultiselect('.styledMultipleSelect--regions', 'region', { single: 'région', multiple: 'régions' });
        initMultiselect('.styledMultipleSelect--solution', 'solution', { single: 'solution', multiple: 'solutions' });
        initMultiselect('.styledMultipleSelect--types', 'type', { single: 'usage', multiple: 'usages' });
    }


    ////////////////////////////////////////////
    /// BLOG                               /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-blog')) {
        let articlesPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;
        let respirationsData = $('.articlesList').attr('data-respirations');

        const resetArticlesVars = () => {
            articlesPaged = 1;
        };

        let doArticlesAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.articlesList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.articlesList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'articles_ajax',
                    paged: articlesPaged,
                    offset: 1,
                    category: url.searchParams.get('category'),
                    respirations: respirationsData
                },
                success: function (result) {
                    if (append) {
                        $('.articlesList').find('.loadMoreButton').remove();
                        $('.articlesList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.articlesList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initArticlesLoadMore();
                    loadImages();
                    scroll.update();
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };

        $('.articlesCategories').find('a').on('click', function (e) {
            e.preventDefault();

            articlesPaged = 1;
            url.searchParams.delete('pg');

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') != 'all') {
                    $(this).removeClass('active');
                }
            } else {
                $('.articlesCategories .active').removeClass('active');
                $(this).addClass('active');
            }

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') == 'all') {
                    url.searchParams.delete('category');
                } else {
                    url.searchParams.set('category', $(this).attr('data-value'));
                }
            } else {
                url.searchParams.delete('category');
            }

            Utils.updateUrl(url.href);
            doArticlesAjax();
        });

        initMobileFilter(doArticlesAjax, resetArticlesVars);

        let initArticlesLoadMore = () => {
            $('.articlesList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                articlesPaged++;
                url.searchParams.set('pg', articlesPaged);
                Utils.updateUrl(url.href);
                doArticlesAjax(true);
            });
        };

        initArticlesLoadMore();

        //
        //////////////////////////////////

        // Open select
        ////////////////////////////////////

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const restBtn = document.querySelector('.blog__reset-btn');

        let terms = {
            category: urlParams.get('category') ? urlParams.get('category') : 'all',
            thematics: urlParams.get('thematics') ? urlParams.get('thematics') : 'all',
            type_post: urlParams.get('type_post') ? urlParams.get('type_post') : 'all',
        };

        // If params
        ///////////////////////////////////////
        if (queryString) {
            for (const term of Object.keys(terms)) {
                
                const value = terms[term]

                if (value !== "all") {

                    restBtn.classList.remove('--disabled')
                    
                    const select = document.querySelector(`.custom__select[data-filter="${term}"]`)
                    const item = select.querySelector(`.custom__select-choice[href="#${value}"]`)
                    const choiceText = item.querySelector('.choice__text').innerText

                    select.querySelector('.custom__select-btn-text').innerText = choiceText
                    select.querySelector('.custom__select-btn').classList.add('--active')

                    item.closest('li').classList.add('--disable')

                }

            }
        }

        // Click btn select
        /////////////////////////////////////////
        $('.custom__select-btn').on('click', function(e){
            e.preventDefault();
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')
        })

        // On click choice
        /////////////////////////////////////////
        $('.custom__select-choice').on('click', function(e){
            
            e.preventDefault();

            const value = $(this).attr('href').substr(1);
            const term = $(this).closest('.custom__select').data('filter');
            let url = new URL(window.location);

            if (value === "all") {
                const selectTitle = $(this).closest('.custom__select').data('text')
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(selectTitle)
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('.custom__select').find('.custom__select-btn').removeClass('--active')

                url.searchParams.delete(term);
            } else {
                //change text
                const choiceText = $(this).find('.choice__text').text()
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(choiceText)
                $(this).closest('.custom__select').find('.custom__select-btn').addClass('--active')

                //Hide option
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('li').addClass('--disable')

                //url
                url.searchParams.set(term, value);
            }

            //close select
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')

            //update terms object
            terms[term] = value;

            // Reset btn
            restBtn.classList.remove('--disabled')

            //update URL
            Utils.updateUrl(url.href);

            //filter
            filterAjaxBlog(term)
            $('.loadMoreButton').hide();
        
        })

        

        restBtn.addEventListener('click', function(e){

            e.preventDefault();

            let url = new URL(window.location);

            //reset object terms
            terms = {
                category: 'all',
                thematics: 'all',
                type_post: 'all'
            };

            //reset select
            const selects = document.querySelectorAll('.custom__select');

            selects.forEach(select => {

                let term = select.dataset.filter;
                const selectTitle = select.dataset.text;
                const items = select.querySelectorAll('li')

                select.querySelector('.custom__select-btn-text').innerText = selectTitle
                select.querySelector('.custom__select-btn').classList.remove('--active')

                items.forEach(item => {
                    item.classList.remove('--disable')

                    item.querySelector('a').classList.remove('--disabled')
                })

                url.searchParams.delete(term);
                Utils.updateUrl(url.href);

            })

            filterAjaxBlog()

            restBtn.classList.add('--disabled')

        })

        let filterAjaxBlog = function (valueClicked = null, append = false) {
            url = new URL(window.location);

            if (append) {
                $('.articlesList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.articlesList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: "get_article_by_term",
                    terms: terms
                },
                success: function (result) {

                    if (append) {
                        $('.articlesList').find('.loadMoreButton').remove();
                        $('.articlesList').find('.ajaxList').find('.ajaxList_results').append($(result.html).html());
                    } else {
                        $('.articlesList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result.html).html());
                    }

                    initArticlesLoadMore();
                    loadImages();
                    scroll.update();
                    updateFilterCount(valueClicked, result.data)

                    
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };

        /**
         * 
         * @param {*} datas : json receive with Ajax
         */
        const updateFilterCount = (valueClicked = null, datas) => {
            
            // Compter le nombre de custom selects avec une sélection active
            const activeSelects = document.querySelectorAll('.custom__select-btn.--active').length;
            
            for (const terms of Object.keys(datas)) {
            
                const termItems = datas[terms];
                
                termItems.forEach(item => {

                    const choiceElement = document.querySelector(`.custom__select-choice[data-id="${item.id}"]`)
                    const choiceElementCount = choiceElement.querySelector('.choice__count')
                    const choiceSelect = choiceElement.closest('.custom__select');

                    // Si un terme est sélectionné dans cette catégorie, on met tous les autres à 0
                    if (choiceSelect.querySelector('.custom__select-btn.--active')) {
                        choiceElementCount.innerText = ''
                    } else {
                        // On met à jour le compteur pour tous les éléments
                        if (item.count === 0) {
                            choiceElementCount.innerText = ''
                        } else {
                            choiceElementCount.innerText = `(${item.count})`
                        }
                    }

                    // Si il n'y a aucun filtre actif, on affiche tous les éléments
                    if (activeSelects === 0) {
                        choiceElement.classList.remove('hidden')
                    } else if (activeSelects > 1) {
                        // Si il y a plus d'une sélection active, on masque tous les éléments avec count = 0
                        if (item.count === 0) {
                            choiceElement.classList.add('hidden')
                        } else {
                            choiceElement.classList.remove('hidden')
                        }
                    } else {
                        // Si il n'y a qu'une seule sélection active, on affiche tous les éléments du custom select sélectionné
                        if (choiceSelect.querySelector('.custom__select-btn.--active')) {
                            choiceElement.classList.remove('hidden')
                        } else {
                            // Pour les autres custom selects, on masque les éléments avec count = 0
                            if (item.count === 0) {
                                choiceElement.classList.add('hidden')
                            } else {
                                choiceElement.classList.remove('hidden')
                            }
                        }
                    }
                })
            }
        }

    }

    ////////////////////////////////////////////
    /// PRESS                              /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-press')) {
        let pressPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;
        let respirationsData = $('.pressList').attr('data-respirations');

        let doPressAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.pressList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.pressList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'press_ajax',
                    paged: pressPaged,
                    offset: 1,
                    category: url.searchParams.get('category'),
                    respirations: respirationsData
                },
                success: function (result) {
                    if (append) {
                        $('.pressList').find('.loadMoreButton').remove();
                        $('.pressList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.pressList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initPressLoadMore();
                    loadImages();
                    scroll.update();
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };


        let initPressLoadMore = () => {
            $('.pressList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                pressPaged++;
                url.searchParams.set('pg', pressPaged);
                Utils.updateUrl(url.href);
                doPressAjax(true);
            });
        };

        initPressLoadMore();

    }


    ////////////////////////////////////////////
    /// EVENEMENTS                         /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-events')) {
        let eventsPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;

        const resetEventsVars = () => {
            eventsPaged = 1;
        };

        let doEventsAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.eventsList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.eventsList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'events_ajax',
                    paged: eventsPaged,
                    offset: 1,
                    category: url.searchParams.get('category')
                },
                success: function (result) {
                    if (append) {
                        $('.eventsList').find('.loadMoreButton').remove();
                        $('.eventsList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.eventsList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initEventsLoadMore();
                    loadImages();
                    scroll.update();
                },
                error: function (result) { console.log("ERROR", result); },
            });
        };

        $('.eventsCategorie').find('a').on('click', function (e) {
            e.preventDefault();

            eventsPaged = 1;
            url.searchParams.delete('pg');

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') != 'all') {
                    $(this).removeClass('active');
                }
            } else {
                $('.eventsCategorie .active').removeClass('active');
                $(this).addClass('active');
            }

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') == 'all') {
                    url.searchParams.delete('category');
                } else {
                    url.searchParams.set('category', $(this).attr('data-value'));
                }
            } else {
                url.searchParams.delete('category');
            }

            Utils.updateUrl(url.href);
            doEventsAjax();
        });

        initMobileFilter(doEventsAjax, resetEventsVars);

        let initEventsLoadMore = () => {
            $('.eventsList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                eventsPaged++;
                url.searchParams.set('pg', eventsPaged);
                Utils.updateUrl(url.href);
                doEventsAjax(true);
            });
        };

        initEventsLoadMore();
    }

    ////////////////////////////////////////////
    /// SEARCH                        /////
    ////////////////////////////////////////////
    if (document.body.classList.contains('page-template-tpl-search')) {
        const restBtn = document.querySelector('.filterReset');
        const loadAjax = ()=>{
            const loadMoreBtns = document.querySelectorAll('.loadMoreButton')
            const rows = {
                event:'.event_row',
                post:'.articles_row',
                'white-book':'.articles_row',
                'infographic':'.articles_row',
                'casclient':'.casclients_row',
                'faq':'.faqs_row',
                'solution':'.solution_row',
                'our-company':'.our-company_row',
                'press':'.press_row',
            }
            url = new URL(window.location);
            let query = url.searchParams.get('search')
            loadMoreBtns.forEach(btn=>{
                btn.addEventListener('click',()=>{
                    const currentPage = btn.getAttribute('data-current-page')
                    const group = btn.closest('[data-group]').getAttribute('data-group')
                    const content = btn.closest('[data-collapse-content]')
                    btn.classList.add('loadMoreButton--loading');
                    $.ajax({
                        url: ajaxVars.url,
                        type: 'post',
                        data: {
                            action: 'search_ajax',
                            data:{
                                page: parseInt(currentPage) + 1,
                                type:group,
                                query:query
                            }
                        },
                        success: function (result) {
                            btn.classList.remove('loadMoreButton--loading')
                            if (!result.data.has_more) {
                                btn.style.display = 'none'
                            }else{
                                btn.setAttribute('data-current-page',parseInt(currentPage) + 1)
                            }
                            console.log(rows[group]);
                            content.querySelector(rows[group]).innerHTML += result.data.items_html;
                            let contentHeight = content.querySelector('[data-collapse-content-inner]').offsetHeight;
                            anime({
                                targets: content,
                                height: contentHeight,
                                easing: 'easeOutExpo',
                                duration: 600,
                                complete: () => { 
                                    scroll.update();
                                 }
                            });
                            loadImages();
                        },
                        error: function (result) { console.log("ERROR", result); },
                    });
                })
            })
        }
        const filter = ()=>{

            url = new URL(window.location);
            let category = url.searchParams.get('category')
            if (category) {
                document.querySelector('.filterReset').classList.add('visible')
                document.querySelectorAll('[data-group]').forEach(group=>{
                    if (group.getAttribute('data-group') !== category) {
                        group.style.display = 'none'
                    }
                    if (group.getAttribute('data-group') == category) {
                        group.style.display = 'block'
                    }
                })
             }else{
                 document.querySelector('.filterReset').classList.remove('visible')
                 document.querySelectorAll('[data-group]').forEach(group=>{
                    group.style.display = 'block'
                })
             }

            scroll.update()
        }
        loadAjax();
        initMobileFilter(filter, false);


        // Click btn select
        /////////////////////////////////////////
        $('.custom__select-btn').on('click', function(e){
            e.preventDefault();
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')
        })

        // On click choice
        /////////////////////////////////////////
        $('.custom__select-choice').on('click', function(e){
            
            e.preventDefault();

            const value = $(this).attr('href').substr(1);

            let url = new URL(window.location);

            if (value === "all") {
                const selectTitle = $(this).closest('.custom__select').data('text')
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(selectTitle)
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('.custom__select').find('.custom__select-btn').removeClass('--active')

                url.searchParams.delete(value);
            } else {
                //change text
                const choiceText = $(this).find('.choice__text').text()
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(choiceText)
                $(this).closest('.custom__select').find('.custom__select-btn').addClass('--active')

                //Hide option
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('li').addClass('--disable')
                url.searchParams.set('categorie',value)
            }

            //close select
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')

            if (value) {
                document.querySelector('.filterReset').classList.add('visible')
                document.querySelectorAll('[data-group]').forEach(group=>{
                    if (group.getAttribute('data-group') !== value) {
                        group.style.display = 'none'
                    }
                    if (group.getAttribute('data-group') == value) {
                        group.style.display = 'block'
                    }
                })
             }else{
                 document.querySelector('.filterReset').classList.remove('visible')
                 document.querySelectorAll('[data-group]').forEach(group=>{
                    group.style.display = 'block'
                })
             }
            scroll.update()
        
        })


        restBtn.addEventListener('click', function(e){

            e.preventDefault();

            let url = new URL(window.location);

            //reset object terms
            terms = {
                category: 'all',
            };

            //reset select
            const selects = document.querySelectorAll('.custom__select');

            selects.forEach(select => {

                let term = select.dataset.filter;
                const selectTitle = select.dataset.text;
                const items = select.querySelectorAll('li')

                select.querySelector('.custom__select-btn-text').innerText = selectTitle
                select.querySelector('.custom__select-btn').classList.remove('--active')

                items.forEach(item => {
                    item.classList.remove('--disable')

                    item.querySelector('a').classList.remove('--disabled')
                })

                url.searchParams.delete(term);
                Utils.updateUrl(url.href);

            })

            restBtn.classList.add('hidden')
            document.querySelectorAll('[data-group]').forEach(group=>{
                group.style.display = 'block'
            })
            scroll.update()

        })

    }


    ////////////////////////////////////////////
    /// FAQ                                /////
    ////////////////////////////////////////////
    if (document.querySelector('.faqCategories')) {
        document.querySelectorAll('.faqCategories a').forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let category = link.getAttribute('data-category');
                let elt = document.querySelector('.faqCategory[data-category="' + category + '"]');
                scrollTo(elt, -70);
            });
        });

        initFaqMobile();
    }


    ////////////////////////////////////////////
    /// FOOTER MENU MOBILE                 /////
    ////////////////////////////////////////////
    if (document.querySelectorAll('.footer_navMain .menu-item-has-children').length) {
        document.querySelectorAll('.footer_navMain .menu-item-has-children').forEach((li) => {
            let link = li.querySelector('a');
            let submenu = li.querySelector('.sub-menu');
            link.addEventListener('click', (e) => {
                e.preventDefault();
                $(submenu).slideToggle();

                if (link.classList.contains('opened')) {
                    link.classList.remove('opened');
                } else {
                    link.classList.add('opened');
                }
            });
        })
    }

    window.addEventListener('message', event => {
        
        if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
            setTimeout(() => {
                scroll.update();
                scrollTo('.submitted-message', -180);
            }, 500);
        }
     });

    if (document.body.classList.contains('page-template-tpl-contact')) {
        if (document.querySelectorAll('.contact-control').length > 1) {
            document.querySelectorAll('.contact-control input').forEach((radio) => {
                radio.addEventListener('change', () => {
                    document.querySelector('.formContainer.active').classList.remove('active');
                    document.querySelector('.formContainer--' + radio.value).classList.add('active');
                    initTextareas();
                });
            });
        }
    }

};

const initPage = () => {
    createScroll();
    WU.scrollToTop();
    page();
};

const hideLoading = (delay = 800) => {
    // anime({
    //     targets: ['.loadingScreen_progress'],
    //     opacity: [1, 0],
    //     duration: 800,
    //     delay: delay,
    // });

    anime({
        targets: '.loadingScreen',
        translateY: '-101%',
        easing: 'easeInOutExpo',
        duration: 1200,
        delay: delay + 100,
    });

    anime({
        targets: '.loadingScreen_inner',
        translateY: '101%',
        easing: 'easeInOutExpo',
        duration: 1200,
        delay: delay + 100,
        complete: () => {
            document.querySelector('.loadingScreen_progress_value').innerHTML = '0%';
            document.querySelector('.loadingScreen').classList.remove('visible');
            // anime.set('.loadingScreen_progress_bar', { translateY: '100%' });
        }
    });
}

(function () {

    Utils.preloadHTMLImages(document.body.innerHTML).then(() => {
        initPage();
        hideLoading();
    });

    document.addEventListener("imageLoaded", function (e) {
        let pct = Math.ceil((e.detail.value / e.detail.total) * 100);

        document.querySelector('.loadingScreen_progress_value').innerHTML = pct + '%';
        // anime.set('.loadingScreen_progress_bar', { scale: (100 - pct) + "%" });
    });

    barba.hooks.enter((data) => {
        scrollTop(true);

    });

    barba.hooks.after(() => {
        scroll.update();
        const pageElement = document.querySelector('.page-template-default');
        if (pageElement) {
            const classes = pageElement.classList;
            const pageIdClass = [...classes].find(cls => cls.startsWith('page-id-'));
            
            if (pageIdClass) {
                const pageId = pageIdClass.replace('page-id-', '');
                if (pageId === '11410') {
                    const script = document.createElement('script');
                    script.textContent = "pixie('event', 'Lead');";
                    document.body.appendChild(script);
                    const noscriptLead = document.createElement('noscript');
                    noscriptLead.innerHTML = `
                        <img src="https://ib.adnxs.com/pixie?pi=a1e9e8af-ccb7-45b3-b064-4a13c7166d02&e=Lead&script=0" width="1" height="1" style="display:none"/>
                    `;
                    document.body.appendChild(noscriptLead);
                }
            }
        }
    });
    
    barba.hooks.afterLeave((data) => {
        const js = data.next.container.querySelectorAll("script.reload-on-ajax");
        [].forEach.call(js, function (script) {
            window.eval(script.innerHTML);
        });
        if(document.querySelector('.mainMenuMobile.visible')){
            document.querySelector('.mainMenuMobile.visible').remove();
        }
    });

    barba.init({
        debug: false,
        timeout: 10000,
        cacheIgnore: true,
        transitions: [
            {
                name: 'default',
                leave() {
                    return new Promise(resolve => {
                        document.querySelector('.loadingScreen').classList.add('visible');
                        anime({
                            targets: '.loadingScreen',
                            translateY: ['101%', '0%'],
                            easing: 'easeInOutExpo',
                            duration: 1200,
                        });

                        anime({
                            targets: '.loadingScreen_inner',
                            translateY: ['-101%', '0%'],
                            easing: 'easeInOutExpo',
                            duration: 1200,
                            complete: resolve
                        });

                        // anime({
                        //     targets: ['.loadingScreen_progress'],
                        //     delay: 400,
                        //     duration: 800,
                        //     opacity: [0, 1]
                        // });
                    });
                },
                enter(data) {
                    let done = this.async();
                    Utils.setNewAttrs(data.next.html);
                    Utils.preloadHTMLImages(data.next.html).then(() => {
                        done();

                        setTimeout(() => {
                            gform.domLoaded = !0;
                            new Forms();
                            page()
                        }, 600);
                        window.addEventListener('gform_loaded',()=>{
                            initCustomSelect();
                        })
                        hideLoading();
                    });
                }
            }
        ]
    });

    jQuery(document).on('gform_post_render', function(formId, currentPage) {        
        initCustomSelect();
    });

})();